import React from "react";

import Button from "../Button";

import rocket from "./rocket.svg";

import styled from "styled-components/macro";

const Wrapper = styled.div`
  h1 {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.35;
    color: #343a40;
    margin-bottom: 20px;
  }
  p {
    margin-bottom: 20px;
  }
  button {
    max-width: 220px;
    margin: 0 auto;
    display: block;
  }
`;

function AcceptLinkSuccess({ company, vinculations, onContinue, t }) {
  return (
    <Wrapper data-test="accept-link-successful">
      <img src={rocket} style={{ marginBottom: 20 }} alt="" />
      <h1>{t("components:AcceptLinkSuccess.great")}</h1>
      <p>
        {t("components:AcceptLinkSuccess.hasBeenAccepted")}
        <strong>
          {vinculations.length === 1
            ? vinculations[0].name
            : t("AcceptLinkSuccess.multipleCompanies", {
                ammount: vinculations.length
              })}
        </strong>{" "}
        {t("components:AcceptLinkSuccess.toMakeVisibleOn", {
          companyName: company.name
        })}
        <br />
        <br />
        {t("components:AcceptLinkSuccess.ifChangeOpinion")}{" "}
        <strong> {t("components:AcceptLinkSuccess.linksPath")}</strong>
      </p>
      <Button size="lg" block type="primary" onClick={onContinue}>
        {t("global:continue")}
      </Button>
    </Wrapper>
  );
}

export default AcceptLinkSuccess;
